import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Cookies = () => {
    return (
        <div className="bg-black text-[#DBCE97] min-h-screen">
            <Header />
            <main className="container-custom pb-24 mb-12 space-y-12" style={{ paddingTop: '7rem' }}>
                <header className="space-y-4">
                    <p className="text-sm uppercase tracking-[0.2em] text-[#D4AF37]">Política de Cookies</p>
                    <h1 className="text-4xl md:text-5xl font-outfit font-bold text-white">Política de Cookies</h1>
                    <p className="text-base text-[#c9bc85] max-w-3xl">
                        En cumplimiento de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE), NOESIS ALTIUS S. COOP. AND (EVOLVANCE) le informa sobre el uso de cookies en su sitio web https://evolvance.es.
                    </p>
                </header>

                <section className="space-y-4 bg-white/5 border border-white/10 rounded-2xl p-6 md:p-8">
                    <h2 className="text-2xl font-semibold text-white">1. ¿Qué son las cookies?</h2>
                    <p>
                        Una cookie es un pequeño archivo de texto que se descarga en su equipo (ordenador, smartphone o tablet) al acceder a determinadas páginas web. Las cookies permiten a una web, entre otras cosas, almacenar y recuperar información sobre los hábitos de navegación de un usuario o de su equipo y, dependiendo de la información que contengan, pueden utilizarse para reconocer al usuario.
                    </p>
                </section>

                <section className="space-y-4 bg-white/5 border border-white/10 rounded-2xl p-6 md:p-8">
                    <h2 className="text-2xl font-semibold text-white">2. Tipos de cookies según su finalidad</h2>
                    <p>Siguiendo las guías de la AEPD, las cookies utilizadas en este sitio web se clasifican en:</p>
                    <ul className="space-y-4">
                        <li>
                            <strong className="text-white">Cookies Técnicas (Necesarias):</strong> Son aquellas que permiten al usuario la navegación a través de la página web y la utilización de las diferentes opciones o servicios que en ella existen, como controlar el tráfico, identificar la sesión o acceder a partes de acceso restringido. No requieren el consentimiento del usuario.
                        </li>
                        <li>
                            <strong className="text-white">Cookies de Preferencias o Personalización:</strong> Permiten recordar información para que el usuario acceda al servicio con determinadas características (por ejemplo, el idioma).
                        </li>
                        <li>
                            <strong className="text-white">Cookies de Análisis o Medición:</strong> Permiten cuantificar el número de usuarios y realizar la medición y análisis estadístico de la utilización que hacen los usuarios del servicio ofertado.
                        </li>
                        <li>
                            <strong className="text-white">Cookies de Publicidad Comportamental:</strong> Almacenan información del comportamiento de los usuarios obtenida a través de la observación continuada de sus hábitos de navegación, lo que permite desarrollar un perfil específico para mostrar publicidad en función del mismo.
                        </li>
                    </ul>
                </section>

                <section className="space-y-4 bg-white/5 border border-white/10 rounded-2xl p-6 md:p-8">
                    <h2 className="text-2xl font-semibold text-white">3. Cookies utilizadas en este sitio web</h2>
                    <p>A continuación, se detallan las cookies que se utilizan en https://evolvance.es:</p>
                    <div className="overflow-x-auto mt-4">
                        <table className="w-full text-left border-collapse">
                            <thead>
                                <tr className="border-b border-white/10">
                                    <th className="py-2 pr-4 text-white">Nombre</th>
                                    <th className="py-2 px-4 text-white">Proveedor</th>
                                    <th className="py-2 px-4 text-white">Finalidad</th>
                                    <th className="py-2 px-4 text-white">Duración</th>
                                    <th className="py-2 pl-4 text-white">Tipo</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="border-b border-white/5">
                                    <td className="py-2 pr-4">_ga</td>
                                    <td className="py-2 px-4">Google Analytics</td>
                                    <td className="py-2 px-4">Análisis estadístico de visitas y tráfico web.</td>
                                    <td className="py-2 px-4">2 años</td>
                                    <td className="py-2 pl-4">Terceros</td>
                                </tr>
                                <tr className="border-b border-white/5">
                                    <td className="py-2 pr-4">_gid</td>
                                    <td className="py-2 px-4">Google Analytics</td>
                                    <td className="py-2 px-4">Recuento de páginas vistas y comportamiento del usuario.</td>
                                    <td className="py-2 px-4">24 horas</td>
                                    <td className="py-2 pl-4">Terceros</td>
                                </tr>
                                <tr className="border-b border-white/5">
                                    <td className="py-2 pr-4">cookielawinfo-checkbox-necessary</td>
                                    <td className="py-2 px-4">Propia</td>
                                    <td className="py-2 px-4">Almacena el estado de consentimiento de cookies del usuario.</td>
                                    <td className="py-2 px-4">1 año</td>
                                    <td className="py-2 pl-4">Técnica</td>
                                </tr>
                                <tr>
                                    <td className="py-2 pr-4">_fbp</td>
                                    <td className="py-2 px-4">Meta/Facebook</td>
                                    <td className="py-2 px-4">Seguimiento de conversiones y optimización de campañas de Ads.</td>
                                    <td className="py-2 px-4">3 meses</td>
                                    <td className="py-2 pl-4">Publicidad</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <p className="text-sm italic mt-4 text-[#c9bc85]">
                        Nota: Como empresa de tecnología y marketing, si utilizáis herramientas de automatización o píxeles de seguimiento (HubSpot, LinkedIn Insight, etc.), debéis añadirlos a esta tabla.
                    </p>
                </section>

                <section className="space-y-4 bg-white/5 border border-white/10 rounded-2xl p-6 md:p-8">
                    <h2 className="text-2xl font-semibold text-white">4. Transferencias internacionales de datos</h2>
                    <p>
                        Algunas de las cookies de terceros mencionadas (como Google o Meta) pueden transferir datos fuera del Espacio Económico Europeo, principalmente a EE.UU. EVOLVANCE se asegura de que dichos proveedores cumplan con marcos de transferencia de datos seguros o cláusulas contractuales tipo aprobadas por la Comisión Europea.
                    </p>
                </section>

                <section className="space-y-4 bg-white/5 border border-white/10 rounded-2xl p-6 md:p-8">
                    <h2 className="text-2xl font-semibold text-white">5. Configuración, aceptación y revocación del consentimiento</h2>
                    <p>
                        El usuario tiene la posibilidad de aceptar, rechazar o configurar las cookies la primera vez que accede al sitio web mediante el Panel de Configuración de Cookies.
                    </p>
                    <p>
                        Asimismo, puede permitir, bloquear o eliminar las cookies instaladas en su equipo mediante la configuración de las opciones del navegador instalado en su ordenador:
                    </p>
                    <ul className="list-disc list-inside space-y-1">
                        <li>Chrome: <a href="https://support.google.com/chrome/answer/95647?hl=es" target="_blank" rel="noopener noreferrer" className="text-[#D4AF37] hover:underline">Enlace a soporte</a></li>
                        <li>Firefox: <a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias" target="_blank" rel="noopener noreferrer" className="text-[#D4AF37] hover:underline">Enlace a soporte</a></li>
                        <li>Safari: <a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer" className="text-[#D4AF37] hover:underline">Enlace a soporte</a></li>
                        <li>Edge: <a href="https://support.microsoft.com/es-es/microsoft-edge/eliminar-las-cookies-en-microsoft-edge-63496c4b-930c-3856-a90c-bb2912014618" target="_blank" rel="noopener noreferrer" className="text-[#D4AF37] hover:underline">Enlace a soporte</a></li>
                    </ul>
                </section>

                <section className="space-y-4 bg-white/5 border border-white/10 rounded-2xl p-6 md:p-8">
                    <h2 className="text-2xl font-semibold text-white">6. Actualizaciones y cambios</h2>
                    <p>
                        EVOLVANCE puede modificar esta Política de Cookies en función de nuevas exigencias legislativas, reglamentarias, o con el objeto de adaptar dicha política a las instrucciones dictadas por la Agencia Española de Protección de Datos.
                    </p>
                </section>
            </main>
            <Footer />
        </div>
    );
};

export default Cookies;
